import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Box, Button, IconButton, TextField, CircularProgress } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import NakdanButton from "../../SharedArea/NakdanButton";
import { observer } from "mobx-react-lite";
import additionalInfo from "../../../Mobx/AdditionalInfo";

const NewDistractingForOriginalSection = observer(() => {
    const newInfo = additionalInfo.newInfo;
    const expanded = additionalInfo.expandedState;
    const loading = additionalInfo.loading;

    const handleToggle = () => {
        additionalInfo.setExpandedState({ ...expanded, distractingForOriginal: !expanded.distractingForOriginal });
    };

    return (
        <Grid item xs={12}>
            <Accordion expanded={expanded.distractingForOriginal} onChange={() => handleToggle("distractingForOriginal")} sx={{ boxShadow: 3, borderRadius: 2, width: "100%" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">({newInfo.distractingForOriginal?.length || 0}) יצירת מסיחים עבור אוריגינאל</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ width: "100%", textAlign: "center" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => additionalInfo.createWithAi("distractingForOriginal")}
                        sx={{ mb: 2 }}
                        disabled={loading.create.distractingForOriginal}
                    >
                        {loading.create.distractingForOriginal ? <CircularProgress size={24} /> : "צור"}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => additionalInfo.addAllExistsInfo("distractingForOriginal")}
                        sx={{ mb: 2, ml: 1 }}
                        disabled={additionalInfo.loading.addAllExistsInfo.distractingForOriginal || newInfo.distractingForOriginal?.length === 0}
                    >
                        {additionalInfo.loading.addAllExistsInfo.distractingForOriginal ? <CircularProgress size={24} /> : "שמור הכל"}
                    </Button>
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={() => additionalInfo.deleteAllNewInfo("distractingForOriginal")}
                        sx={{ mb: 2, ml: 1 }}
                        disabled={newInfo.distractingForOriginal?.length === 0}
                    >
                        מחק הכל
                    </Button>

                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1,
                            justifyContent: "flex-start",
                            alignItems: "flex-start"
                        }}
                    >
                        {newInfo.distractingForOriginal?.length > 0 ? (
                            newInfo.distractingForOriginal.map((distr, index) =>
                                <Box
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        bgcolor: "#f0f0f0",
                                        p: 1,
                                        borderRadius: 2,
                                        maxWidth: "210px",
                                        minWidth: "100px",
                                        flex: "1 0 auto"
                                    }}
                                >
                                    <Box sx={{ display: "flex", gap: 0, ml: 1 }}>
                                        {/* כפתור ניקוד */}
                                        <NakdanButton
                                            text={distr}
                                            onNikudComplete={(nikudText) => {
                                                additionalInfo.editNewInfo("distractingForOriginal", index, nikudText);
                                            }}
                                        />
                                        {/* כפתור שמירה */}
                                        <IconButton
                                            onClick={() =>
                                                additionalInfo.addExistsInfo({
                                                    fields: { distrForOriginal: distr },
                                                    field: "distractingForOriginal",
                                                    index
                                                })
                                            }
                                            disabled={additionalInfo.loading.addExistsInfo.distractingForOriginal?.[index]}
                                        >
                                            {distr && (additionalInfo.loading.addExistsInfo.distractingForOriginal?.[index]
                                                ? <CircularProgress size={24} />
                                                : <SaveIcon color="primary" />)}
                                        </IconButton>
                                        {/* כפתור מחיקה */}
                                        <IconButton onClick={() => additionalInfo.deleteNewInfo("distractingForOriginal", index)}>
                                            <DeleteIcon color="error" />
                                        </IconButton>
                                    </Box>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        multiline
                                        minRows={1}
                                        value={distr}
                                        onChange={(e) => additionalInfo.editNewInfo("distractingForOriginal", index, e.target.value)}
                                        sx={{
                                            direction: /^[\u0590-\u05FF]/.test(distr) ? "ltr" : "rtl",
                                            flexGrow: 1
                                        }}
                                    />
                                </Box>
                            )
                        ) : (
                            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Typography variant="body2" color="textSecondary">לא נוצרו מסיחים עבור אוריגינאל</Typography>
                            </Box>
                        )}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
});

export default NewDistractingForOriginalSection;
